<template>
  <section class="article">
    <div class="article__content container">
      <div class="article__image --fade-in-right" data-vertical-ivp-class="--animate">
        <a href="https://www.streetinsider.com/Investor+Brand+Network/GeoSolar+Technologies+Inc.+Seeks+to+Target+the+Impending+Global+Energy+Crisis/20430798.html" target="_blank">
          <img src="../assets/article/article2.png">
        </a>
      </div>
      <div class="article__text --fade-in-left" data-vertical-ivp-class="--animate">
        <a href="https://www.streetinsider.com/Investor+Brand+Network/GeoSolar+Technologies+Inc.+Seeks+to+Target+the+Impending+Global+Energy+Crisis/20430798.html" class="title" target="_blank">
          GeoSolar Technologies Inc. Seeks to Target the Impending Global Energy Crisis </a> <br>
        <a href="https://www.streetinsider.com/Investor+Brand+Network/GeoSolar+Technologies+Inc.+Seeks+to+Target+the+Impending+Global+Energy+Crisis/20430798.html" class="link" target="_blank">
          StreetInsider.com </a>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: 'Article',
  data () {
    return {
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import "../styles/components/article.scss";
</style>
